import { Link } from 'react-router-dom';

interface ArticleCardProps {
  title: string;
  slug: string;
  excerpt: string;
  category: string;
  author: string;
  date: string;
  imageUrl: string;
  tags: string[];
  readTime: number;
}

const categoryMap: Record<string, string> = {
  dianying: '电影',
  dianshiju: '电视剧',
  jilupian: '纪录片',
  dongman: '动漫',
  zongyi: '综艺',
};

export default function ArticleCard({ title, slug, excerpt, category, author, date, imageUrl, tags, readTime }: ArticleCardProps) {
  return (
    <article className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 group flex flex-col sm:flex-row">
      <div className="sm:w-56 h-44 sm:h-auto overflow-hidden shrink-0">
        <img
          src={imageUrl}
          alt={title}
          title={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="p-4 flex flex-col justify-between flex-1">
        <div>
          <div className="flex items-center gap-2 mb-2">
            <span className="text-xs bg-secondary-100 text-secondary-700 px-2 py-0.5 rounded-full whitespace-nowrap">
              {categoryMap[category] || category}
            </span>
            <span className="text-xs text-foreground-500">{date}</span>
            <span className="text-xs text-foreground-400">{readTime}分钟阅读</span>
          </div>
          <Link to={`/article/${slug}`}>
            <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 hover:text-primary-500 transition-colors line-clamp-2">
              {title}
            </h3>
          </Link>
          <p className="text-sm text-foreground-600 leading-relaxed mb-3 line-clamp-2">{excerpt}</p>
        </div>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <span className="text-xs text-foreground-500">{author}</span>
            <div className="flex gap-1">
              {tags.slice(0, 3).map((tag) => (
                <span key={tag} className="text-xs text-foreground-400 bg-background-100 px-1.5 py-0.5 rounded whitespace-nowrap">
                  {tag}
                </span>
              ))}
            </div>
          </div>
          <Link
            to={`/article/${slug}`}
            className="text-sm text-primary-500 hover:text-primary-600 font-medium flex items-center gap-1 whitespace-nowrap"
          >
            阅读全文
            <i className="ri-arrow-right-line w-3 h-3 flex items-center justify-center"></i>
          </Link>
        </div>
      </div>
    </article>
  );
}